export const AttachmentInfoTableHeaders = [
    'SERIAL NUMBER',
    'TYPE',
    'MAKE',
    'MODEL',
    'CLASS',
    'CAPACITY',
    'NOSE SIZE',
    'POINT SHAPE',
    'WEIGHT',
    'LIP WIDTH',
    'BUCKET ID NUMBER',
]

export const PointsTableHeaders = [
    'part_number',
    'description',
    'pmid',
    'component_quantity',
]

export const KeysToRemoveFromPoints = ['attachment_type']

export const KeysToRemoveFromAttachmentInfo = [
    'image_rear_view',
    'item_number',
    'image_left_hand_view',
    'image_right_hand_view',
    'item_sup',
    'bucket_literature',
    'description',
    'capacity',
    'components',
    'image_side_view',
]
